import { Component, ElementRef, HostListener, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import {DropdownToggleService} from '../../../../../shared/services/dropdown-toggle.service';
import { AuthService } from '@core/services/auth.service';
import { Observable, of } from 'rxjs';
import { User } from '@core/model/user/user';
import { Business } from '@core/model/business/business';
import { BusinessService } from '../../../pages/profile/services/business.service';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { environment } from '@environment/environment';

@Component({
  selector: 'app-profile',
  standalone: false,
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css',
  animations: [
    trigger('expandCollapse', [
      state('expanded', style({
        height: '*',
        opacity: 1,
        padding: '*'
      })),
      state('collapsed', style({
        height: '0px',
        opacity: 0,
        padding: '0'
      })),
      transition('expanded <=> collapsed', [
        animate('500ms ease')
      ]),
    ])
  ]
})
export class ProfileComponent implements OnInit {
  @ViewChild('dropdownTemplate') dropdownTemplate!: TemplateRef<any>;
  @ViewChild('triggerBtn', { read: ElementRef }) triggerBtn!: ElementRef;
  @Input() inlineMode: boolean = false;   // new input
  accordionStates: { [key: string]: number } = {}; // store open index for each accordion group
  user$: Observable<User>;
  defaultBusiness: any;
  isAdmin: boolean;
  businesses: Business[] = [];
  pic = null;
  ngOnInit(): void {
    this.auth.user$.subscribe((x) => {
      this.user$ = of(x);
    });
    this.businessService
      .getMyActiveBusinesses()
      .subscribe((x) => (this.businesses = x));

    this.auth.business$.subscribe((selectedBusiness) => {
      this.defaultBusiness = selectedBusiness;
      this.isAdmin =
        this.auth.isAgentAdmin() ||
        this.auth.isTimeTrackingAdmin() ||
        this.auth.isHrAdmin() ||
        this.auth.isFinanceAdmin();
    });
  }
  constructor(
    protected dropdownService: DropdownToggleService,
    public auth: AuthService,
    private businessService: BusinessService,
    private overlayDropdownService: DropdownToggleService,
    private viewContainerRef: ViewContainerRef,
    private router: Router
  ) {
    this.auth.user$.subscribe((x) => {
      this.user$ = of(x);
    });
  }

  // Toggle a specific dropdown
  toggleDropdown(id: string, event: MouseEvent): void {
    event.stopPropagation();
    this.dropdownService.toggleDropdown(id);
  }

  // Check if a dropdown is visible
  isDropdownVisible(id: string): boolean {
    return this.dropdownService.isDropdownVisible(id);
  }

  onLinkClick(event: MouseEvent): void {
    event.stopPropagation();
    this.dropdownService.hideAllDropdowns();
  }

  // Hide all dropdowns when clicking anywhere else in the document
  @HostListener('document:click', ['$event'])
  onDocumentClick(_event?: Event): void {
    this.dropdownService.hideAllDropdowns();
  }

  onDivClick(event: MouseEvent): void {
    event.stopPropagation(); // Prevent document click listener from closing dropdown
  }

  logout() {
    this.auth.logout();
  }

  /** Opens in-app Business Profile (tabbed hub). Optional `environment.businessProfileUrl` overrides. */
  goToBusinessProfile(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    this.overlayDropdownService.closeDropdown();
    this.dropdownService.hideAllDropdowns();

    const businessId = this.auth.businessId;
    const custom = environment.businessProfileUrl?.trim() ?? '';

    if (custom) {
      const authBase = String(environment.authUrl ?? '').replace(/\/+$/, '');
      const target = custom
        .replace(/\{businessId\}/g, encodeURIComponent(businessId))
        .replace(/\{authUrl\}/g, authBase);
      if (target.startsWith('/')) {
        void this.router.navigateByUrl(target);
        return;
      }
      if (/^https?:\/\//i.test(target)) {
        window.location.assign(target);
        return;
      }
    }

    void this.router.navigateByUrl('/business-profile');
  }

  isActive(id: string) {
    return id === this.defaultBusiness.id;
  }
  async setAsDefault(business: Business) {
    if (business.id === this.auth.businessId) return;
    this.auth.business$.next(business);
    await this.auth.switchTenant(business);
    window.location.reload();
  }

  toggleDisplay() {
    document.body.removeAttribute('data-offcanvas-offcanvas');
    const getId = document.getElementById('kt_quick_user');
    getId.classList.remove('offcanvas-on');
    getId.nextSibling.remove();
    let getGro = document.getElementById('kt_quick_user_toggle');
    function handleClick() {
      getGro.click();
    }
    handleClick();
  }
  isAllowed() {
    return (
      this.auth.isOwner() || this.auth.isHrAdmin() || this.auth.isHrManager()
    );
  }
  toggleDropdownMat() {
    if (this.inlineMode) return; // disable when inline
    this.overlayDropdownService.openDropdown(
      this.dropdownTemplate,
      this.viewContainerRef,
      {
        top: 60,
        right: 22
      }
    );
  }

  toggle(group: string, index: number) {
    this.accordionStates[group] =
      this.accordionStates[group] === index ? -1 : index;
  }
}
